[
    {
        "id": "TMTTRT51CX",
        "name": "bignerve",
        "title": "BigNerve",
        "slogan": "An innovator community",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "bignerve",
        "slug": "bignerve",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "2RV484TTTD",
        "name": "nervonah",
        "title": "NerVonAh",
        "slogan": "The best solution is a great question",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "nervonah",
        "slug": "nervonah",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "2ZV484ANDX",
        "name": "comedynerve",
        "title": "ComedyNerve",
        "slogan": "Unleash your irreverent soul",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "comedy",
        "slug": "comedy",
        "type": "system-platform",
        "marketing_phrase": "Spread happiness"
    },
    {
        "id": "6CACF7VP7D",
        "name": "dailynerve",
        "title": "DailyNerve",
        "slogan": "Solve the News",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "daily",
        "slug": "daily",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "8KKJTYRUDD",
        "name": "admin",
        "title": "Admin Panel",
        "slogan": "Restricted area",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "admin",
        "slug": "admin",
        "type": "system-platform",
        "marketing_phrase": "Admin Panel"
    },
    {
        "id": "AGF1THXCJV",
        "name": "politicalnerve",
        "title": "PoliticalNerve",
        "slogan": "Promote political change",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "political",
        "slug": "political",
        "type": "system-platform",
        "marketing_phrase": "Promote political change"
    },
    {
        "id": "DXK9MRKYE8",
        "name": "bignerveold",
        "title": "BigNerveOld",
        "slogan": "An innovator community",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "bignerveold",
        "slug": "bignerveold",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "KKM1NC84XW",
        "name": "captionnerve",
        "title": "CaptionNerve",
        "slogan": "When you just can't find the...",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "caption",
        "slug": "caption",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "KZNYATH177",
        "name": "buildnerve",
        "title": "BuildNerve",
        "slogan": "Imagine our Future Spaces",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "build",
        "slug": "build",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "M022NJ7X87",
        "name": "lyfenerve",
        "title": "LyfeNerve",
        "slogan": "Before you decide",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "lyfe",
        "slug": "lyfe",
        "type": "system-platform",
        "marketing_phrase": "It's not always obvious what is obvious"
    },
    {
        "id": "1AF2546DDR",
        "name": "mainenerve",
        "title": "MaineNerve",
        "slogan": "The way life could be",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "maine",
        "slug": "maine",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "",
        "name": "businessnerve",
        "title": "BusinessNerve",
        "slogan": "Think tanks for business",
        "icon": "",
        "createdAt": "0001-01-01T00:00:00Z",
        "updatedAt": "0001-01-01T00:00:00Z",
        "deletedAt": null,
        "subdomain": "business",
        "slug": "business",
        "type": "system-platform",
        "marketing_phrase": "The place for imagination and insight"
    },
    {
        "id": "4HOHLKSQO5",
        "name": "claremont",
        "title": "ClaremontNerve",
        "slogan": "Intellectually curious",
        "icon": "",
        "createdAt": "2023-04-24T00:00:00Z",
        "updatedAt": "2023-04-24T00:00:00Z",
        "deletedAt": null,
        "subdomain": "claremont",
        "slug": "claremont",
        "type": "system-platform",
        "marketing_phrase": "Collaborative, responsive, and responsible leadership"
    },
    {
        "id": "RPGTRT52CX",
        "name": "rpgnerve",
        "title": "RPGNerve",
        "slogan": "Imagine other worlds",
        "icon": "",
        "createdAt": "2024-05-08 14:02:02",
        "updatedAt": "2024-05-08 14:02:02",
        "deletedAt": null,
        "subdomain": "rpg",
        "slug": "rpg",
        "type": "system-platform",
        "marketing_phrase": "Multiplayer roleplay and storytelling"
    },
    {
        "id": "SKEPTIC2CX",
        "name": "skeptic",
        "title": "Skeptic",
        "slogan": "Examining the world through science",
        "marketing_phrase": "",
        "icon": "",
        "subdomain": "skeptic",
        "url": "https://skeptic.bignerve.com",
        "type": "system-platform",
        "owner": "SKEPTIC2CX",
        "slug": "skeptic",
        "organization_image": null,
        "organization_description": null,
        "masthead_background_image": ""
    },
    {
        "id": "FICTION2CX",
        "name": "fiction",
        "title": "FictionNerve",
        "slogan": "Where words collide",
        "icon": "",
        "url": "https://fiction.bignerve.com",
        "subdomain": "fiction",
        "slug": "fiction",
        "owner": "FICTION2CX",
        "type": "system-platform",
        "organization_image": "",
        "organization_detail": "",
        "masthead_background_image": "https://bignerve-images.s3.us-west-2.amazonaws.com/images/f5585835-8abe-41cb-a89d-2deeacca4954",
        "marketing_phrase": "What happens next is up to you"
    }
]